export default "__VITE_ASSET__5f3edc2b__"